(function($){

class Announcements {
    constructor() {
        this.$banner = $('.announcement-banner');
        this.$cta = $('.announcement-banner .announcement-cta');
        this.$closeBtn = $('.announcement-banner .close-banner');

        this.setupEvents();

        setTimeout(() => {
            this.show();
        }, 1000);
    }

    setupEvents() {
        this.$cta.on('click', () => { this.disableBannerForSession(); });
        this.$closeBtn.on('click', () => { this.closeBanner(); });
    }

    show() {
        if(!this.$banner || this.$banner.length <= 0) { return; }
        const hideAnnouncement = (sessionStorage.getItem('hideAnnouncement') === 'true' ? true : false);
        if(hideAnnouncement) { this.$banner.remove(); return; }

        this.$banner.addClass('shown');
    }

    closeBanner() {
        this.$banner.removeClass('shown');
        this.disableBannerForSession();
        setTimeout(() => {
            this.$banner.remove();
        }, 1200);
    }

    disableBannerForSession() {
        sessionStorage.setItem('hideAnnouncement', 'true');
    }
}

$(document).ready(function() {
    new Announcements();
})

})(jQuery)